import React from "react";
import {AddonStore} from "../../../../stores/addons-store-list";
import GridLine, {BackgroundColor} from "../../../../../../../components/layouts/grid-line-layout/grid-line/grid-line";
import FontBody2 from "../../../../../../../components/fonts/font-body2/font-body2";
import {FONT_COLOR, FONT_VARIANT} from "../../../../../../../components/fonts/font-props";

const ChangedAddonGridLine: React.FC<{ addon: AddonStore}> = ({addon}) => {
    return <GridLine
        key={addon.id}
        withBorder={false}
        withoutSidePadding={true}
        backgroudColor={BackgroundColor.LIGHT}
        settings={
            {
                columns: [{width: 5}, {width: 2.5}, {width: 4}]
            }
        }
        columns={[
            <div>
                <FontBody2 color={FONT_COLOR.PRIMARY2}>
                    {addon.displayName}
                </FontBody2>
            </div>,
            <div>
                {addon.isQuotaBased() &&
                    <FontBody2 color={FONT_COLOR.ACCENT1}>
                        {addon.featureQuota < 0 ? '-'+-addon.featureQuota : '+'+addon.featureQuota}
                    </FontBody2>
                }
            </div>,
            <div>
                <FontBody2 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>
                    ${addon.addonPrice.toFixed(2)}
                </FontBody2>
            </div>
        ]}
    />
}

export default ChangedAddonGridLine;